import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Modal = ({
  id,
  children,
  modalClass = "modal-dialog",
  contentClass = "",
  labelledBy,
  staticBackdrop = false,
  keyboardClose = true,
  show = false,
  onClose
}) => {
  useEffect(() => {
    const modalElement = document.getElementById(id);

    if (show) {
      // Slide the modal in from the bottom with fade in when shown
      modalElement.style.transform = 'translateY(100%)';
      modalElement.style.opacity = '0';
      modalElement.style.display = 'block';
      modalElement.classList.add('show');
      setTimeout(() => {
        modalElement.style.transition = 'transform 0.3s ease-out, opacity 0.3s ease-out';
        modalElement.style.transform = 'translateY(0)';
        modalElement.style.opacity = '1';
      }, 10);

      document.body.classList.add('modal-open');
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = '0px';

      const backdropDiv = document.createElement('div');
      backdropDiv.className = 'modal-backdrop fade show';
      document.body.appendChild(backdropDiv);

      // Add click handler for backdrop
      if (!staticBackdrop && onClose) {
        backdropDiv.addEventListener('click', onClose);
      }

      return () => {
        modalElement.style.transition = 'transform 0.3s ease-out, opacity 0.3s ease-out';
        modalElement.style.transform = 'translateY(100%)';
        modalElement.style.opacity = '0';
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        if (document.body.contains(backdropDiv)) {
          document.body.removeChild(backdropDiv);
        }
      };
    }
  }, [show, id]);

  // Handle click outside modal content
  const handleModalClick = (e) => {
    if (e.target === e.currentTarget && !staticBackdrop && onClose) {
      onClose();
    }
  };

  // Handle keyboard events for accessibility
  const handleKeyDown = (e) => {
    if (e.key === 'Escape' && keyboardClose && !staticBackdrop && onClose) {
      onClose();
    }
  };

  return (
    <div
      className="modal fade"
      id={id}
      aria-labelledby={labelledBy}
      aria-modal="true"
      tabIndex="-1"
      data-bs-backdrop={staticBackdrop ? "static" : true}
      data-bs-keyboard={keyboardClose}
      onClick={handleModalClick}
      onKeyDown={handleKeyDown}
    >
      <div className={`${modalClass} SideModal modal-dialog-scrollable modal-lg`}>
        <div className={`modal-content ${contentClass}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

// Prop types validation
Modal.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  modalClass: PropTypes.string,
  contentClass: PropTypes.string,
  labelledBy: PropTypes.string,
  staticBackdrop: PropTypes.bool,
  keyboardClose: PropTypes.bool,
  show: PropTypes.bool,
  onClose: PropTypes.func
};

// Default props
Modal.defaultProps = {
  modalClass: "modal-dialog",
  contentClass: "",
  staticBackdrop: false,
  keyboardClose: true,
  show: false
};


export const ModalBody = ({ children, className = "" }) => {
  return (
    <div className={`modal-body ${className}`}>
      {children}
    </div>
  );
};

// PropTypes for ModalBody
ModalBody.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export const ModalHeader = ({ children, className = "" }) => {
  return (
    <div className={`modal-header ${className}`}>
      {children}
    </div>
  );
};

// PropTypes for ModalHeader
ModalHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export const ModalFooter = ({ children, className = "" }) => {
  return (
    <div className={`modal-footer ${className}`}>
      {children}
    </div>
  );
};

// PropTypes for ModalFooter
ModalFooter.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default Modal;